import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { HeaderModule } from "src/app/ui-widgets/header/header.module";
import { ProductFiltersModule } from "src/app/ui-widgets/product-filters/product-filters.module";
import { ProductPaginationModule } from "src/app/ui-widgets/product-pagination/product-pagination.module";
import { SidebarModule } from "src/app/ui-widgets/sidebar/sidebar.module";
import { FaqsComponent } from "./faqs.component";
import { FaqsRoutingModule } from "./faqs-routing.module";

@NgModule({
    imports: [
        RouterModule,
        ProductFiltersModule,
        CommonModule,
        HeaderModule,
        SidebarModule,
        ProductPaginationModule,
        FaqsRoutingModule
    ],
    declarations: [
        FaqsComponent
    ]
  })
  export class FaqsModule { }
